var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "sui-table",
        { attrs: { basic: "very", selectable: "" } },
        [
          _c(
            "sui-table-header",
            [
              _c(
                "sui-table-row",
                [
                  _c("sui-table-header-cell"),
                  _vm._l(_vm.columns, function (column, index) {
                    return _c("sui-table-header-cell", { key: index }, [
                      _vm._v(" " + _vm._s(column.text) + " "),
                    ])
                  }),
                  _c("sui-table-header-cell"),
                ],
                2
              ),
            ],
            1
          ),
          _vm.staff
            ? _c(
                "sui-table-body",
                _vm._l(_vm.staff, function (member, index) {
                  return _c(
                    "sui-table-row",
                    { key: index },
                    [
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _c(
                        "sui-table-cell",
                        [
                          _c(
                            "sui-header",
                            { tag: "h4" },
                            [
                              _c("sui-icon", {
                                attrs: {
                                  name: "user circle",
                                  color: "grey",
                                  size: "big",
                                },
                              }),
                              _c(
                                "sui-header-content",
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        member.PreferredName__c +
                                          " " +
                                          member.Name
                                      ) +
                                      " "
                                  ),
                                  _c("sui-header-subheader", [
                                    _vm._v(_vm._s(member.Title__c)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "sui-table-cell",
                        { attrs: { collapsing: "" } },
                        [
                          _c(
                            "sui-header",
                            { tag: "h4" },
                            [
                              _c("sui-icon", {
                                attrs: {
                                  name: "building",
                                  color: "grey",
                                  size: "big",
                                },
                              }),
                              _c(
                                "sui-header-content",
                                [
                                  _c("sui-header-subheader", [
                                    _vm._v(_vm._s(member.FirmId__r.Name)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(member.WorkPhone__c)),
                      ]),
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(member.Mobile_Phone__c)),
                      ]),
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(member.WorkEmail__c)),
                      ]),
                      _vm.user.is_manager
                        ? _c(
                            "sui-table-cell",
                            { attrs: { collapsing: "" } },
                            [
                              _c(
                                "sui-dropdown",
                                {
                                  staticClass: "icon",
                                  attrs: {
                                    icon: "chevron down",
                                    pointing: "center left",
                                  },
                                },
                                [
                                  _c(
                                    "sui-dropdown-menu",
                                    [
                                      _c(
                                        "sui-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.getStaffMember(
                                                member.Id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("sui-icon", {
                                            attrs: {
                                              name: "address card outline",
                                            },
                                          }),
                                          _vm._v("View member "),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "sui-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.getStaffMember(
                                                member.Id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("sui-icon", {
                                            attrs: { name: "edit" },
                                          }),
                                          _vm._v("Edit member "),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }